import React, { Fragment } from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import { formatAmount } from "../../utils";

const CartSummary = ({ cart }) => {
  // Subtotal with GST included
  const subtotal = cart.subTotal;
  const flatDiscount = cart.totalDiscountAmount;
  const shipping = 0;

  // Subtotal after discount
  const subTotalAfterDiscount = subtotal - flatDiscount + shipping;

  const gstRate = 0.18;

  // Extract base price (before GST)
  const subtotalBasePrice = (subTotalAfterDiscount / (1 + gstRate)).toFixed(2);

  // Calculate GST correctly
  const totalGST = (subtotalBasePrice * gstRate).toFixed(2);

  // CGST and SGST (each 9%)
  const totalCGST = (totalGST / 2).toFixed(2);
  const totalSGST = (totalGST / 2).toFixed(2);

  return (
    <Fragment>
      <h6 className="mb-0 fw-semibold">Order Summary</h6>
      <hr />
      <div className="d-flex justify-content-between mb-2">
        <span className="text-light-emphasis">SUBTOTAL (incl. GST)</span>
        <span className="fw-medium">
          <span className="currency">&#8377;</span>
          {formatAmount(cart.subTotal)}
        </span>
      </div>

      {/* Discount Breakdown Accordion */}
      {cart.totalDiscountAmount > 0 && (
        <Accordion className="my-2">
          <Accordion.Item eventKey="discount">
            <Accordion.Header>
              <span className="fw-bold">Discount: </span>
              <span className="text-danger fw-medium ms-2">
                -<span className="currency">₹</span>
                {formatAmount(cart.totalDiscountAmount)}
              </span>
            </Accordion.Header>
            <Accordion.Body className="py-2">
              {cart.discountDetails.map((discount) => (
                <Row className="mb-2" key={discount.code}>
                  <Col>
                    <span className="text-light-emphasis">
                      {discount.name} ({discount.code})
                    </span>
                  </Col>
                  <Col xs="auto" className="text-danger fw-medium">
                    -<span className="currency">₹</span>
                    {formatAmount(discount.totalAmountApplied)}
                  </Col>
                </Row>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* GST Breakdown Accordion */}
      <Accordion className="my-2">
        <Accordion.Item eventKey="gst">
          <Accordion.Header>
            <span className="fw-bold">GST: </span>
            <span className="fw-medium ms-2">
              <span className="currency">₹</span> {formatAmount(totalGST)}
            </span>
          </Accordion.Header>
          <Accordion.Body className="py-2">
            <Row className="mb-2">
              <Col>
                <span className="text-light-emphasis">Base Amount</span>
              </Col>
              <Col xs="auto">
                <span className="currency">₹</span>{" "}
                {formatAmount(subtotalBasePrice)}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <span className="text-light-emphasis">CGST (9%)</span>
              </Col>
              <Col xs="auto">
                <span className="currency">₹</span> {formatAmount(totalCGST)}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <span className="text-light-emphasis">SGST (9%)</span>
              </Col>
              <Col xs="auto">
                <span className="currency">₹</span> {formatAmount(totalSGST)}
              </Col>
            </Row>

            <Row className="mb-2">
              <Col>
                <span className="text-light-emphasis">Total GST (18%)</span>
              </Col>
              <Col xs="auto">
                <span className="currency">₹</span> {formatAmount(totalGST)}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <hr />
      <div className="d-flex justify-content-between">
        <span className="text-light-emphasis">SHIPPING</span>
        <span className="fw-medium">Free</span>
      </div>
      <hr />
      <div className="d-flex justify-content-between fs-6">
        <span className="text-light-emphasis">TOTAL</span>
        <span className="fw-medium">
          <span className="currency">&#8377;</span>
          {formatAmount(cart.total)}
        </span>
      </div>
    </Fragment>
  );
};

export default CartSummary;
